import React, {useEffect, useRef, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import './Css/Print.css';
import PNG from "../Image/PNG.png";
import PDF from "../Image/PDF.png";
import XSL from "../Image/XSL.png";
import config from "../ip.json"
import {ExcelExporter} from "../DataBind/excel/bind";
import {PaymentData} from "../DataBind/Payment";
import Swal from "sweetalert2";

import CheckOutChip from "../Components/CheckOutChip";
import axios from "axios";
import CompanyInfoChip from "../Components/CompanyInfoChip";

const getList = async (companyName) => {
    const jwtToken = sessionStorage.getItem("Authorization");

    try {
        const response = await axios.get(config.url + "/v2/payment/company", {
            params: {
                name: companyName,
            },
            headers: {
                Authorization: jwtToken,
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });

        // 데이터가 배열인지 확인
        if (Array.isArray(response.data)) {
            console.log("받은 데이터:", response.data);
            return response.data; // 데이터를 반환
        } else {
            console.warn("Response data is not an array, converting it.");
            return [];
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
            icon: "error",
            title: "데이터 요청 실패",
            text: "데이터를 가져오는 중 문제가 발생했습니다.",
        });
        return null; // 오류 발생 시 null 반환
    }
};

const Print = () => {
    // 예시 데이터: 회사 목록

    const navigate = useNavigate();

    const location = useLocation();
    const [checked, setChecked] = useState(false); // '모두 선택' 체크박스 상태
    const [selectCount, setSelectCount] = useState(0); // 선택된 항목 개수
    const [selectedItems, setSelectedItems] = useState([]); // 선택된 항목을 관리하는 배열
    const [companyArr, setCompanyArr] = useState([]); // 선택된 항목을 관리하는 배열
    const [companyNameArr, setCompanyNameArr] = useState([]); // 선택된 항목을 관리하는 배열
    const inputRef = useRef();
    const [loding, setLoding] = useState(true); // 로딩 상태
    const [dwLoading, setDwLoading] = useState(true); // 로딩 상태


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(config.url + "/v2/company/all", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    withCredentials: true, // 쿠키 필요 시 설정
                });
                setCompanyArr(response.data); // 회사 목록 업데이트
                setLoding(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                alert("데이터를 가져오는 중 문제가 발생했습니다.");
            }
        };

        fetchData(); // 비동기 함수 호출
    }, []); // 초기 로드 시 실행

    useEffect(() => {
        const nameArr = companyArr.map((item) => item.company); // 회사 이름 배열 생성
        setCompanyNameArr(nameArr);
    }, [companyArr]); // companyArr 변경 시 실행


    // '모두 선택' 체크박스를 클릭하면 전체 선택/해제
    const handleSelectAllChange = () => {
        setChecked(!checked); // '모두 선택' 체크박스 상태 변경

        if (!checked) {
            // 모두 선택
            setSelectedItems(companyNameArr);
            setSelectCount(companyNameArr.length);
        } else {
            // 모두 해제
            setSelectedItems([]);
            setSelectCount(0);
        }
    };

    // 개별 항목의 체크박스 상태가 변경될 때 호출되는 함수
    const handleCheckChange = (chipName, isChecked) => {
        let newSelectedItems;
        if (isChecked) {
            newSelectedItems = [...selectedItems, chipName]; // 선택된 항목 추가
        } else {
            newSelectedItems = selectedItems.filter(item => item !== chipName); // 선택된 항목 제거
        }

        setSelectedItems(newSelectedItems);
        setSelectCount(newSelectedItems.length);
    };

    const handleChange = () => {
        setChecked(!checked);
    };


    const handleInput = (event) => {
        const input = event.target;
        input.style.height = "auto"; // 높이를 초기화
        input.style.height = input.scrollHeight + "px"; // 스크롤 높이에 따라 설정
    };

    // 초기값: state에서 받거나 기본값 설정
    const [name, setName] = useState(location.state?.name || companyArr[0]);

    const handleBackClick = () => {
        // navigate(-1); // 이전 페이지로 이동
    };

    const handleChipClick = (chipName) => {
        setName(chipName); // 선택한 회사 이름으로 상태 업데이트
    };
    const handleShowSelectedItems = () => {
        if (selectedItems.length > 0) {
            alert(`현재 선택된 항목: ${selectedItems.join(", ")}`);
        } else {
            alert("현재 선택된 항목이 없습니다.");
        }
    };

    const printExcel = async () => {
        const newArr = companyArr.filter(item => selectedItems.includes(item.company));
        if (newArr.length > 0) {
            setDwLoading(false)
            const exporter = new ExcelExporter();
            for (const item of newArr) {
                (await getList(item.company))?.forEach(payment => {
                    exporter.push_item(PaymentData.fromObject(payment));
                });
            }
            let text = exporter.finalize();
            text.then(result => {
                setDwLoading(true)
            });
        } else {
            alert("출력할 기업을 왼쪽에서 선택 해 주세요.");
        }
    };
    const printPng = () => {
        console.log(companyArr);
        const newArr = companyArr.filter(item => selectedItems.includes(item.company));
        if (newArr.length > 0) {
            navigate('/Printing', {state: {newArr: newArr, fileType: 'png', bigoInfo: bigoInfo}});
        } else {
            alert("출력할 기업을 왼쪽에서 선택 해 주세요.");
        }
    };
    const printPdf = () => {
        console.log(companyArr);
        const newArr = companyArr.filter(item => selectedItems.includes(item.company));
        if (newArr.length > 0) {
            navigate('/Printing', {state: {newArr: newArr, fileType: 'pdf', bigoInfo: bigoInfo}});
        } else {
            alert("출력할 기업을 왼쪽에서 선택 해 주세요.");
        }
    };
    const [bigoInfo, setBigoInfo] = useState("");

    // 비고란 입력 이벤트 핸들러
    const handleBigoChange = (event) => {
        setBigoInfo(event.target.value); // 입력된 내용을 상태로 업데이트
    };

    return (
        <div className="registration-container">
            <div
                className="black-blur"
                style={{zIndex: dwLoading ? -999 : 999}}
            >
                <div className="loader">
                    <div className="intern"></div>
                    <div className="external-shadow">
                        <div className="central"></div>
                    </div>
                </div>
            </div>
            <div className="registration-middle-container">
                <div className="print-sidebar">
                    <div className="print-search">
                        <div className="print-checkbox-wrapper">
                            {/* 모두 선택 체크박스 */}
                            <input
                                id={'allCheck'}
                                name="checkbox"
                                type="checkbox"
                                checked={checked}
                                onChange={handleSelectAllChange} // '모두 선택' 클릭 시 호출
                                style={{display: "none"}}
                            />
                            <label className="terms-label" htmlFor={'allCheck'}>
                                <SVGIcon checked={checked}/>
                                <span className="label-text">{`모두 선택 (${selectCount}/${companyArr.length})`}</span>
                            </label>
                        </div>
                    </div>

                    {loding ? (
                        <div className="sidebar-loader"></div> // 로딩 스피너 출력
                    ) : (
                        companyNameArr.map((chipName) => (
                            <CheckOutChip
                                key={chipName}
                                label={chipName}
                                id={chipName}
                                state={selectedItems.includes(chipName)} // 해당 회사가 선택되었는지 여부
                                onCheckChange={handleCheckChange} // 체크박스 상태 변경 시 호출되는 함수
                            />
                        ))
                    )}

                </div>
                {/* 메인 박스 */}
                <div className="print-mainbox">
                    <div className={'print-title'}>고지서 출력</div>
                    <div className={'print-sub-title'}>업체를 선택하고 각 업체의 고지서를 다운받아보세요.</div>
                    <div className={'print-box'}>
                        <div className={'print-box-title'}>
                            {"다운로드 전 [ 크롬 -> 설정 -> 다운로드 -> 위치 ]에서 다운로드 위치를 원하는 곳에 지정해주세요."}
                        </div>
                        <div className={'print-btn-box'}>
                            <div className={'print-pdf-btn'} onClick={printPng}>
                                <img className="PNG" src={PNG}/>PNG로 다운받기

                            </div>
                            <div className={'print-png-btn'} onClick={printPdf}>
                                <img className="PDF" src={PDF}/>PDF로 다운받기

                            </div>
                        </div>
                        <div className={'print-excel-btn'} onClick={printExcel}>
                            <img className="XSL" src={XSL}/>Excel로 정보 다운받기

                        </div>
                        <div className={'print-bigo'}>
                            <div className={'print-bigo-title'}>비고란 작성</div>
                            <textarea
                                ref={inputRef}
                                className="custom-input"
                                placeholder="비고란에 들어갈 내용을 작성해주세요. 미기입시 비고란은 공백으로 처리됩니다."
                                onInput={handleInput}
                                onChange={handleBigoChange} // 입력 이벤트 핸들러 추가
                            />
                            {/*<div className={'print-save-btn'}>저장</div>*/}
                        </div>
                        {/*<div className="print-show-btn">*/}
                        {/*    <button onClick={handleShowSelectedItems}>선택된 항목 보기</button>*/}
                        {/*</div>*/}

                    </div>

                </div>

            </div>
        </div>

    );
};


// SVG 아이콘 (체크박스 스타일)
const SVGIcon = ({checked}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 200 200"
            className="checkbox-svg"
        >
            <mask fill="white" id="path-1-inside-1">
                <rect height="200" width="200"></rect>
            </mask>
            <rect
                mask="url(#path-1-inside-1)"
                strokeWidth="40"
                className="checkbox-box"
                height="200"
                width="200"
                style={{
                    strokeDashoffset: checked ? "0" : "800", // 애니메이션
                }}
            ></rect>
            <path
                strokeWidth="15"
                d="M52 111.018L76.9867 136L149 64"
                className="checkbox-tick"
                style={{
                    strokeDashoffset: checked ? "0" : "172", // 애니메이션
                }}
            ></path>
        </svg>
    );
};

export default Print;
